
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Send, Trash2 } from 'lucide-react';

interface ErrorLogHeaderProps {
  errorCount: number;
  onSendAllReports: () => void;
  onClearErrors: () => void;
}

const ErrorLogHeader: React.FC<ErrorLogHeaderProps> = ({ 
  errorCount, 
  onSendAllReports, 
  onClearErrors 
}) => {
  return (
    <div className="flex justify-between items-center">
      <h2 className="text-xl font-semibold flex items-center gap-2">
        <AlertTriangle className="h-5 w-5 text-amber-500" />
        Error Logs
        {errorCount > 0 && (
          <Badge variant="destructive" className="ml-2">
            {errorCount}
          </Badge>
        )}
      </h2>
      
      <div className="flex gap-2">
        {errorCount > 0 && (
          <>
            <Button 
              size="sm" 
              variant="outline" 
              onClick={onSendAllReports}
            >
              <Send className="h-4 w-4 mr-1" />
              Send All Reports
            </Button>
            <Button 
              size="sm" 
              variant="destructive" 
              onClick={onClearErrors}
            >
              <Trash2 className="h-4 w-4 mr-1" />
              Clear All
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default ErrorLogHeader;
